module.exports = __webpack_public_path__ + "static/media/arrow-left-black.dcb4104a.svg";